export default {
  user: {},
  loggingOut: false,
  firm: 'SK',
  year: new Date().getFullYear(),
  history: '/',
  aclList: {},
  locations: [],
  emptyLocations: false,
  settings: {},
  userHistory: [],
  carts: [],
  menuState: false,
  activeMenuItem: '',
  menuItems: [],
};



// WEBPACK FOOTER //
// ./src/Store/state.js